import * as React from 'react';
import { observer } from 'mobx-react';
import { loaderStore } from '@app/Stores/LoaderStore';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';

interface ILoadingProps {
    fullpage?: boolean;
    loading?: boolean;
    isSuspense?: boolean;
    className?: string;
}

@observer
export class Loading extends React.Component<ILoadingProps, {}> {
    render() {
        const { fullpage, loading, className, isSuspense } = this.props;
        const visible = loading || loaderStore.globalLoader.isPending || isSuspense;
        let classStr = className ? [className] : ['loader'];
        let style: React.CSSProperties = fullpage ? { position: 'fixed' } : { position: 'absolute' };
        if (isSuspense) {
            style = {};
            classStr.push('loader-suspense');
        }
        return (
            <div hidden={!visible}
                className={classStr.join(' ')}
                style={style}>
                <Spinner size={SpinnerSize.large} className="loader-icon" />
            </div>
        );
    }
}
